import { Navigate, Outlet, useLocation } from "react-router";
import { Notice } from "../design/components";
import type { Role } from "../api/types";
import { useAuth } from "./AuthProvider";
import { SignOutLink } from "./SignOutLink";

const AUDIENCE: Record<Role, string> = {
  group_admin: "group administrators",
  entity_admin: "company administrators",
  finance: "finance users",
  readonly: "read-only users",
};

export function RequireRole({ role }: { role: Role }) {
  const { me, status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="page-loading" role="status" aria-label="Loading">
        <span className="page-loading-dot" />
      </div>
    );
  }

  if (status === "anonymous" || !me) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/signin?next=${next}`} replace />;
  }

  if (me.surface === "portal") return <Navigate to="/portal" replace />;

  if (me.role !== role) {
    return (
      <main className="page">
        <Notice kind="fail">
          <p>{`This area is for ${AUDIENCE[role]}`}</p>
          <SignOutLink />
        </Notice>
      </main>
    );
  }

  return <Outlet />;
}
